// import Vue from 'vue'
// import _ from 'lodash'

let api = {}

api.COMMON_PROPS = [
    "children",
    "componentType",
    "expression",
    "name",
    "node",
    "nodeUUID",
    "paused",
    "parentNodeUUID",
    "propsData",
    "options",
    "parameters"
]

/**
 * Se usa para computar la propiedad pasada como parametro. Para ello,
 * convierte el atributo en una funcion y la evalua.
 */
api.methods = {
    get(k) { return window.api.get(k)},
    // __(k) { return window.api.get(k)},

    /*
    Sirve para evaluar cadenas de caracteres pero no soporta eventos porque
    el elemento no se anade al dom. Pero de aqui surge RenderString.

    evalTemplate(template, context) {
        window.console.log('evalTemplate tempalte', template)
        window.console.log('evalTemplate context', context)
        if(!template) return null;
        template = template.startsWith('<') ? template: '<span>' + template + '</span>';
        let el = Vue.compile(template)

        el = new Vue({
            components: {},
            render: el.render,
            data: { ...context.node, ...context },
            methods: {  },
            staticRenderFns: el.templateRenderFns
        }).$mount()
        let r =  el.$el.innerHTML
        // window.console.log('evalTemplate>', r)
        return r;
    }
    */
}

api.data = () => {}

api.computed = {

}

export default api;